import { useMemo } from 'react';

export default function useUniqueId() {
  const uniqueId = useMemo(
    () => (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}_${Math.floor(Math.random() * 10000)}`,
    [],
  );

  return uniqueId;
}
